import React from 'react';
import moment, { Moment } from 'moment';

export const DateWithoutTimeZone = ({ date }: { date: string | Moment }) => {
  const formattedDate = moment(date).format('MM/DD/YYYY');

  return <> {formattedDate} </>;
};
